module.exports = __webpack_public_path__ + "img/week.6f9a5ed7.svg";